<template>
  <div id="contenedor-main-pagos">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainPagos',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
